import { FileSelectionHelper } from "@/Common/Helpers/FileSelectionHelper";
import { FileType } from "@/Common/Models/FileType";
import { SignedPrintAuthorization } from "@/Common/Models/SignedPrintAuthorization";

class AttachedObjectResponse {
    public Id: string;
    public Type: FileType;
    public ObjectId: string;
    public Description: string;
    public AssociatedSignedPrintAuthorization?: SignedPrintAuthorization;

    public constructor(init?: Partial<AttachedObjectResponse>) {
        Object.assign(this, init);
    }

    public get InternalId(): string {
        return `${this.Type}_${this.ObjectId}`;
    }

    public static getDisplayName(obj: AttachedObjectResponse): string {
        if (!obj)
            return "";

        if (obj.Description)
            return obj.Description;

        return FileSelectionHelper.determineTypeName(obj.Type);
    }
}

export { AttachedObjectResponse };
